module.exports = __webpack_public_path__ + "static/media/caracteristicas.89a30e8d.jpg";